(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["doe-floating-buy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('doe-floating-buy')) {
    customElements.define('doe-floating-buy', class extends HTMLElement {
      connectedCallback() {
        if (this.handleClick) return;
        this.handleClick = () => {
          const product = document.querySelector('product-info[id^="MainProduct-"]');
          const target = product?.querySelector('variant-selects') || product?.querySelector('.doe-cus-shell') || product?.querySelector('product-form') || product?.querySelector('[id^="ProductInfo-"]');
          if (!target) return;
          const header = document.querySelector('.section-header');
          const offset = (header?.getBoundingClientRect().height || 0) + 20;
          target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
          window.scrollTo({ top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.addEventListener('click', this.handleClick);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.handleClick = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
